import { render } from "./LocationBrandingSettings.vue?vue&type=template&id=6dd55fad&scoped=true"
import script from "./LocationBrandingSettings.vue?vue&type=script&lang=js"
export * from "./LocationBrandingSettings.vue?vue&type=script&lang=js"

import "./LocationBrandingSettings.vue?vue&type=style&index=0&id=6dd55fad&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd55fad"]])

export default __exports__